/**
 * For prices less than 0 display first 2 meaningful digits with cap at 8 symbols after 0
 * @param balance number
 * @return {string}
 */
// export const formatAssetBalance = (balance: number): string => {
//   if (balance === 0) {
//     return '0';
//   }

//   if (balance >= 1) return balance.toFixed(2);

//   const decimalDigits = balance.toFixed(20).split('.')[1];

//   if (decimalDigits && Number(decimalDigits.slice(0, 7)) === 0) {
//     const maxPrecision = Number(balance.toFixed(8));

//     return Number(maxPrecision) === 0 ? '0' : balance.toFixed(8);
//   }

//   const firstNonZero = decimalDigits?.match(/[1-9]/)?.index || 0;

//   return balance.toFixed(Math.min(firstNonZero + 2, 8));
// };

export const formatAssetBalance = (balance: number): string => {
  if (balance === 0) return '0';

  let formattedNumber: string;

  if (balance >= 1) {
    formattedNumber = balance.toFixed(2);
  } else {
    const decimalDigits = balance.toFixed(20).split('.')[1];
    if (decimalDigits && Number(decimalDigits.slice(0, 7)) === 0) {
      const maxPrecision = Number(balance.toFixed(8));
      formattedNumber = Number(maxPrecision) === 0 ? '0' : balance.toFixed(8);
    } else {
      const firstNonZero = decimalDigits?.match(/[1-9]/)?.index || 0;
      formattedNumber = balance.toFixed(Math.min(firstNonZero + 2, 8));
    }
  }

  const numberValue = Number(formattedNumber);

  return numberValue.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 8,
  });
};
